window.addEventListener("scroll", function () {
  const div = document.getElementById("myDiv");
  if (window.scrollY > 480) {
    div.classList.add("fixed");
  } else {
    div.classList.remove("fixed");
  }
});

document.addEventListener('DOMContentLoaded', function() {
            // Get all tab links
            const tabLinks = document.querySelectorAll('.festivetabslist a');
            const tabsList = document.querySelector('.festivetabslist');
            
            // Get all sections with class names matching the data-target values
            const sections = document.querySelectorAll('.section--padding');
            
            // Function to check if element is in viewport
            function isElementInViewport(el) {
                const rect = el.getBoundingClientRect();
                const tabsListRect = tabsList.getBoundingClientRect();
                
                return (
                    rect.left >= tabsListRect.left &&
                    rect.right <= tabsListRect.right
                );
            }
            
            // Function to scroll tab into view if not visible
            function scrollTabIntoView(activeTab) {
                if (!isElementInViewport(activeTab)) {
                    const container = tabsList;
                    const tabOffset = activeTab.offsetLeft;
                    const tabWidth = activeTab.offsetWidth;
                    const containerWidth = container.offsetWidth;
                    
                    // Calculate scroll position to center the tab
                    const scrollPosition = tabOffset - 50;
                    
                    // Smooth scroll to the position
                    container.scrollTo({
                        left: scrollPosition,
                        behavior: 'smooth'
                    });
                }
            }
            
            function isSectionInViewport(el) {
                    const rect = el.getBoundingClientRect();
                    const offset = 150; // adjust as needed
                    return rect.top <= offset && rect.bottom >= offset;
                }
            
            // Function to update active tab based on scroll position
            function updateActiveTab() {
                // Reset all tabs
                tabLinks.forEach(link => {
                    link.classList.remove('active');
                });
                
                // Check each section to see if it's in the viewport
                let activeSection = null;
                
                sections.forEach(section => {
                    if (isSectionInViewport(section)) {
                        activeSection = section;
                    }
                });
                
                // If we found a section in view, activate the corresponding tab
                if (activeSection) {
                    // Get the class name that matches our data-target values
                    const sectionClasses = activeSection.className.split(' ');
                    
                    for (let cls of sectionClasses) {
                        // Skip common classes
                        if (cls === 'section' || cls === 'section--padding') continue;
                        
                        // Find and activate the matching tab
                        tabLinks.forEach(link => {
                            if (link.getAttribute('data-target') === cls) {
                                link.classList.add('active');
                                scrollTabIntoView(link);
                            }
                        });
                    }
                }
                
                // If no section is in view and we're at the top, deactivate all tabs
                if (window.scrollY < 100) {
                    tabLinks.forEach(link => link.classList.remove('active'));
                }
            }
            
            // Add click event listeners to tabs for smooth scrolling
            // tabLinks.forEach(link => {
            //     link.addEventListener('click', function(e) {
            //         e.preventDefault();
                    
            //         const targetClass = this.getAttribute('data-target');
            //         const targetSections = document.querySelectorAll(`.${targetClass}`);
                    
            //         if (targetSections.length > 0) {
            //             // Scroll to the first section with this class
            //             window.scrollTo({
            //                 top: targetSections[0].offsetTop - 100,
            //                 behavior: 'smooth'
            //             });
            //         }
            //     });
            // });
            
            // Throttled scroll event listener
            let scrollTimeout;
            window.addEventListener('scroll', function() {
                if (scrollTimeout) {
                    clearTimeout(scrollTimeout);
                }
                scrollTimeout = setTimeout(updateActiveTab, 50);
            });
            
            // Initialize on page load
            updateActiveTab();
            
            // Also update on resize (in case layout changes)
            window.addEventListener('resize', updateActiveTab);
        });